import styled from "styled-components";
import Image from "next/image";
import { breakpoints } from "styles";
import {
  colors,
  radius,
  spacing,
  stroke,
  textStyles,
  toCSS
} from "design-system/foundation";

export const FinishCard = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: ${spacing["4xl"]};
  padding: ${spacing["2xl"]} ${spacing.none} ${spacing["2xl"]};
  border-radius: ${radius.xl};

  @media ${breakpoints.tablet} {
    width: 480px;
    flex: none;
    align-self: center;
    background: ${colors.bg.base.default};
    box-shadow: 0 8px 32px rgba(24, 27, 37, 0.15);
    gap: ${spacing["5xl"]};
    padding: ${spacing["5xl"]};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing["2xl"]};
  margin: auto ${spacing.none};
  padding: ${spacing.none} ${spacing["2xl"]};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  padding: ${spacing["2xl"]} ${spacing["2xl"]} ${spacing.none};
  border-top: ${stroke.xs} solid ${colors.border.state.default};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
    border-top: none;
  }
`;

export const Illustration = styled(Image)`
  width: 256px;
  height: 256px;
`;

export const Title = styled.h1`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h4)};
  text-align: center;
  color: ${colors.text.base.primary};
`;

export const Description = styled.p`
  margin: ${spacing.none};
  text-align: center;
  ${toCSS(textStyles.body.body5Regular)};
  color: ${colors.text.base.secondary};
  strong {
    color: ${colors.text.semantic.success};
  }
`;
export const PointsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xl};
  width: 100%;
  padding: ${spacing["2xl"]};
  border: ${stroke.xs} solid ${colors.border.state.default};
  border-radius: ${radius.sm};
  box-shadow: 0 8px 24px rgba(24, 27, 37, 0.08);
`;

export const PointsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TotalPoints = styled.span`
  ${toCSS(textStyles.caption.caption6)};
  color: ${colors.text.base.primary};
`;

export const Divider = styled.div`
  width: 100%;
  height: ${stroke.xs};
  background-color: ${colors.border.state.default};
`;

export const DetailLabel = styled.span`
  ${toCSS(textStyles.body.body4Regular)};
  color: ${colors.text.base.secondary};
`;

export const DetailValue = styled.span`
  ${toCSS(textStyles.body.body5Bold)};
  color: ${colors.text.base.primary};
`;
